var _path, _path2, _path3, _path4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSellicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_217",
    "data-name": "Group 217",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.773,
    height: 40.773,
    viewBox: "0 0 40.773 40.773",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M2.629,0C4.082,0,5.259.867,5.259,1.938S4.082,3.875,2.629,3.875,0,3.008,0,1.938,1.177,0,2.629,0Z",
    transform: "translate(20.425 5.822)",
    fill: "#afafaf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M2.629,0C4.082,0,5.259.867,5.259,1.938S4.082,3.875,2.629,3.875,0,3.008,0,1.938,1.177,0,2.629,0Z",
    transform: "translate(30.943 5.822)",
    fill: "#afafaf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M2.939,0l-1.7,1.282L0,3.974,2.1,5.605,4.1,2.977Z",
    transform: "matrix(0.602, -0.799, 0.799, 0.602, 11.928, 32.857)",
    fill: "#afafaf"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M2340.093,2283.9l.99-5.349s1.114-1.238.743-1.238a26.217,26.217,0,0,1-3.342-2.1l-1.485-2.847s-.619-5.2-.619-5.57a19.446,19.446,0,0,1,1.609-2.847l3.837-.866,3.713.866,1.609-.866,3.094.866,2.228,1.857v4.951l-.743,2.6-1.485,1.857-3.094,2.1v1.238h1.114l.99,1.609.99,2.352,3.837.619h1.238l.99-2.971-.99-4.332-.5-6.436v-6.312l-2.352-5.075-4.208-2.6-3.837-.743-3.342.743-4.7,3.218-1.361,2.1-1.114,4.085v12.5l-1.238,3.713v1.485l2.352,1.388Z",
    transform: "translate(-2331.986 -2247.674)",
    fill: "#afafaf"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_online_shop_3618145",
    "data-name": "noun_online shop_3618145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M37.485,13.153H35.512V9.847a3.275,3.275,0,0,0,1.315-2.613V5.8L35.133,1.28A1.981,1.981,0,0,0,33.286,0H18.01a1.981,1.981,0,0,0-1.847,1.28L14.468,5.8v.962a11.132,11.132,0,0,0-13.153,11v8.827A14.906,14.906,0,0,1,.244,32.145a3.415,3.415,0,0,0,3.17,4.683h4.53A4.607,4.607,0,0,0,12.5,40.773h5.261a1.947,1.947,0,0,0,.657-.121v.121H36.828V39.458A2.633,2.633,0,0,0,34.2,36.828H32.882V34.2h4.6a3.292,3.292,0,0,0,3.288-3.288V16.441A3.292,3.292,0,0,0,37.485,13.153Zm0,1.315a1.975,1.975,0,0,1,1.973,1.973v11.18H23.724c-.024-.345-.049-.689-.049-1.037V23.675H35.512V14.468ZM34.2,22.36H23.675v-4.6a11.138,11.138,0,0,0-3.6-8.193,3.316,3.316,0,0,0,.316-.37,3.258,3.258,0,0,0,5.256-.007,3.258,3.258,0,0,0,5.261,0A3.263,3.263,0,0,0,34.2,10.456ZM26.305,6.576h3.946v.658a1.973,1.973,0,0,1-3.946,0ZM21.229,5.261l.986-3.946H24.99V5.261Zm-.185,1.315H24.99v.658a1.973,1.973,0,1,1-3.946,0Zm12.5,2.631a1.975,1.975,0,0,1-1.973-1.973V6.576h3.946v.658A1.975,1.975,0,0,1,33.539,9.207Zm-.254-7.892a.661.661,0,0,1,.616.427l1.32,3.519H31.405l-.969-3.946ZM30.066,5.261H26.305V1.315H29.08ZM17.394,1.741a.662.662,0,0,1,.616-.426h2.85l-.986,3.946h-3.8ZM15.783,6.576h3.946v.658a1.969,1.969,0,0,1-.687,1.479,11.127,11.127,0,0,0-3.259-1.641ZM7.892,32.223v3.289H3.414a2.1,2.1,0,0,1-1.949-2.88,16.219,16.219,0,0,0,1.165-6.049V17.756a9.865,9.865,0,0,1,19.729,0v8.827a16.219,16.219,0,0,0,1.165,6.049A2.1,2.1,0,0,1,22.953,35l-.018.009a2.618,2.618,0,0,0-1.891-.81H18.363a5.423,5.423,0,0,0-2.9-4.143,7.241,7.241,0,0,0,5.583-7.037V17.16l-.491-.128a1.97,1.97,0,0,1-1.278-1.054l-.262-.541-.562.212a1.967,1.967,0,0,1-.7.134,2.372,2.372,0,0,1-2.044-.955L15.189,13.8l-.619.977A2.176,2.176,0,0,1,12.5,15.783a2.174,2.174,0,0,1-2.075-1.009L9.8,13.8l-.523,1.032a2.374,2.374,0,0,1-2.045.955,1.96,1.96,0,0,1-.694-.134l-.562-.212-.262.541a1.973,1.973,0,0,1-1.278,1.054l-.491.128v5.858a7.241,7.241,0,0,0,4.941,6.855c-.01.009-.022.016-.031.026A3.264,3.264,0,0,0,7.892,32.223Zm11.837,4.6V36.17a1.951,1.951,0,0,0-.121-.658h1.436a1.317,1.317,0,0,1,1.315,1.315Zm-5.524-5.89.241.091a4.108,4.108,0,0,1,2.6,3.169H14.468V32.224A3.264,3.264,0,0,0,14.206,30.937Zm-3.025-2h-.005a5.925,5.925,0,0,1-5.914-5.919V18.133a3.283,3.283,0,0,0,1.351-1.1,3.088,3.088,0,0,0,.622.064,4.081,4.081,0,0,0,2.637-.929A3.628,3.628,0,0,0,12.5,17.1a3.632,3.632,0,0,0,2.624-.929,4.08,4.08,0,0,0,2.637.929,3.088,3.088,0,0,0,.622-.064,3.279,3.279,0,0,0,1.351,1.1v4.884a5.925,5.925,0,0,1-5.919,5.919H11.18Zm6.576,10.523H12.5a3.292,3.292,0,0,1-3.288-3.288V32.223a1.971,1.971,0,0,1,1.968-1.972h.012a1.974,1.974,0,0,1,1.966,1.972v2.432l-1.2,1.807,1.094.729,1.119-1.68h3.595a.658.658,0,0,1,.658.658v.658h0V38.8A.658.658,0,0,1,17.757,39.458Zm17.756,0H19.729v-.651s0,0,0-.007v-.658H34.2A1.317,1.317,0,0,1,35.512,39.458Zm-3.946-2.631H23.675a2.614,2.614,0,0,0-.1-.673l.042-.022.116-.076A3.4,3.4,0,0,0,24.9,34.2h6.668Zm5.919-3.946H24.94a3.393,3.393,0,0,0-.193-.737,14.884,14.884,0,0,1-.871-3.209H39.458v1.973A1.975,1.975,0,0,1,37.485,32.882Z",
    fill: "#313c40"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 0.692,
    cy: 0.692,
    r: 0.692,
    transform: "translate(36.756 30.179)",
    fill: "#313c40"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 0.554,
    cy: 0.692,
    rx: 0.554,
    ry: 0.692,
    transform: "translate(34.265 30.179)",
    fill: "#313c40"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 0.692,
    cy: 0.692,
    r: 0.692,
    transform: "translate(31.497 30.179)",
    fill: "#313c40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M38,27.207h7.892V18H38Zm1.315-7.892h5.261v6.576H39.315Z",
    transform: "translate(-13.01 -6.163)",
    fill: "#313c40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 1.384,
    height: 1.384,
    transform: "translate(11.014 2.5)",
    fill: "#313c40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 1.384,
    height: 1.384,
    transform: "translate(8.523 2.5)",
    fill: "#313c40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 1.384,
    height: 1.384,
    transform: "translate(3.264 2.5)",
    fill: "#313c40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 1.107,
    height: 1.384,
    transform: "translate(6.032 2.5)",
    fill: "#313c40"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellicon);
export default __webpack_public_path__ + "static/media/sellicon.516fbff0ee546da11b3038bdc3cec371.svg";
export { ForwardRef as ReactComponent };